export const initialSliderGroupState = {
    loading: false,
    error: null,
    dataSliderGroup: null,
};
